import axios from 'axios'
import Vue from 'vue'
const vm = new Vue()

var isRefreshing = false
const requestQueue = []
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

service.interceptors.request.use(config => {
  if (localStorage.token) {
    config.headers['Authorization'] = 'Bearer ' + localStorage.token
  }
  return config
}, error => {
  // Do something with request error
  Promise.reject(error)
})

function getRefreshToken () {
  let refreshConfig = {
    method: 'post',
    url: process.env.VUE_APP_API_URL + 'api/v1/auth/token_refresh',
    headers: {
      'Authorization': `Bearer ` + localStorage.refreshToken
    }
  }
  return axios(refreshConfig)
}

function rejectQueue (err) {
  while (requestQueue.length > 0) {
      let { callback } = requestQueue.shift()
      callback(err)
  }
}
function processQueue () {
  while (requestQueue.length > 0) {
      const { config, callback } = requestQueue.shift()
      config.headers = {
        'Authorization': `Bearer ` + localStorage.token,
        'Content-Type': 'application/json'
      }
      axios(config)
      .then(res => {
          callback(null, res.data)
      })
      .catch(err => {
          callback(err)
      })
  }
}
service.interceptors.response.use(
  response => {
    if (response.status !== 200) {
      if (response.status === 401) {
        vm.$message({
          message: 'Unauthorized!',
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(new Error('error'))
      }
      vm.$message({
        message: response.response,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error('error'))
    } else {
      return response.data
    }
  },
  err => {
    const status = err.response.status
    if (status === 401 && err.config.url.indexOf('/token/refresh') === -1 && err.config.url.indexOf('/auth/login') === -1) {
      if (!isRefreshing) {
        isRefreshing = true
        getRefreshToken().then(response => {
          localStorage.setItem('refreshToken', response.data.refreshToken)
          localStorage.setItem('token', response.data.token)
          processQueue()
          isRefreshing = false
        }).catch(error => {
          if (error.response.status === 401 || error.response.status === 403) {
            vm.$message({
              message: 'Unauthorized!',
              type: 'error',
              duration: 5 * 1000
            })
            localStorage.token = ''
            location.reload()
          }
          rejectQueue(error)
          isRefreshing = false
        })
      }
      return new Promise((resolve, reject) => {
        requestQueue.push({
          config: err.config,
          callback (err, data) {
            if (err) {
              reject(err)
            } else {
              resolve(data)
            }
          }
        })
      })
    } else {
      var errMesasage = err.response.data.message
      if (errMesasage.indexOf('Exception:') !== -1) {
        errMesasage = errMesasage.slice(errMesasage.indexOf('Exception:') + 10, errMesasage.length)
      }
      vm.$message({
        message: errMesasage,
        type: 'error',
        duration: 5 * 1000
      })
      while (requestQueue.length > 0) {
          let { callback } = requestQueue.shift()
          callback(err)
      }
      return Promise.reject(err)
    }
  }
)

export default service
